import { render } from "./PartnerEdit.vue?vue&type=template&id=24266036&scoped=true"
import script from "./PartnerEdit.vue?vue&type=script&lang=js"
export * from "./PartnerEdit.vue?vue&type=script&lang=js"

import "./PartnerEdit.vue?vue&type=style&index=0&id=24266036&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24266036"]])

export default __exports__